'use client';

import React, { createContext, useContext, ReactNode, useMemo } from 'react';
import socketInstance from '@/helpers/singletons/socket';
import { Socket } from 'socket.io-client';

interface ISocketType {
  socket: Socket | null;
  listenWithSocketId: (
    eventName: string,
    callback: (...args: any[]) => void,
  ) => void;
  listen: (event: string, callback: (...args: any[]) => void) => void;
  emit: (event: string, ...args: any[]) => void;
}

const SocketContext = createContext<ISocketType>({} as ISocketType);

export const SocketProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const socket = socketInstance.getSocket();

  const listenWithSocketId = (
    eventName: string,
    callback: (...args: any[]) => void,
  ) => socketInstance.listenWithSocketId(eventName, callback);
  const listen = (event: string, callback: (...args: any[]) => void) =>
    socketInstance.listen(event, callback);
  const emit = (event: string, ...args: any[]) => {
    socketInstance.emit(event, ...args);
  };

  const socketProviderValues = useMemo(
    () => ({ socket, listenWithSocketId, listen, emit }),
    [socket],
  );

  return (
    <SocketContext.Provider value={socketProviderValues}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocket must be used within a SocketProvider');
  }
  return context;
};

export default socketInstance;
